// extracted by mini-css-extract-plugin
export default {"editorViewer":"CKEditorViewer_editorViewer__VIvRR","isPreview":"CKEditorViewer_isPreview__PKIj5","editor":"CKEditorViewer_editor__fko3O"};